export const DomainMapper = {
    "softinya.test": "www",
    "www.softinya.test": "www",
    "portal.meet2talk.online": "meet2talk",
    "egitim.burulas.com.tr": "burulas",
    "next4bizacademy.com":"next4bizacademy",
    "next4bizacademy.next4bizacademy.com":"next4bizacademy",
    "akademi.tigavakfi.org": "tigavakfi",
    "akademi.atonet.org.tr": "ato",
    "akademi.bellona.com.tr": "bellona",
    "akademi.hrup.com.tr": "hrup",
    "prousta.izeltas.com.tr": "izeltaselaletleri",
    "zzzbusinessschool.zsazsazsu.com.tr": "zsazsazsu",
    "academy.atb.az": "azerturkbankojsc",
    "akademi.nadirmetal.com.tr": "nadirmetal",
    "esaslifeacademy.esas.com": "esas",
}
